module.exports = __webpack_public_path__ + "img/chart-network.a680b023.svg";